module.exports = __webpack_public_path__ + "img/2ROSEAPPLE.61a3ccf0.png";